var e = class {
  _;
};
export { e as Any };